import React from "react";
import "./Businesses.css";
import ManImage from "../../../assets/Snaithe Businesses.jpg";

const Businesses = () => {
  return (
    <div className="box-business-man-custom">
      <div className="text-container-business-man-custom">
        <div className="title-business-man-custom">Snáithe's Businesses</div>

        <div className="text-business-man-custom">
          Snáithe's capabilities are as versatile as they are comprehensive. Our
          expertise spans across a myriad of sectors:
          <br />
          <br />
          Business & Industry: Snáithe pioneers innovative solutions that
          invigorate businesses and industries, igniting growth and progress
          through strategic insights and groundbreaking strategies.
          <br />
          <br />
          Government Sector: As a trusted partner to governments, Snáithe
          facilitates transformational initiatives that lead to enhanced public
          services, streamlined operations, and citizen-centric governance.
          <br />
          <br />
          Education: Snáithe is committed to shaping the future of education by
          leveraging cutting-edge technologies to create immersive learning
          experiences, thereby equipping individuals with the skills and
          knowledge needed to thrive in the modern world.
          <br />
          <br />
          IT & AI Industry: With an unwavering focus on the IT and AI landscape,
          Snáithe propels organizations into the digital age, harnessing the
          power of artificial intelligence to unlock new dimensions of
          efficiency and innovation.
          <br />
          <br />
          Vehicle Industry: Snáithe's involvement in the vehicle industry is
          characterized by groundbreaking advancements that drive sustainable
          transportation solutions, revolutionizing the way we commute.
          <br />
          <br />
          Wood & Tire Industry: Through sustainable practices and innovative
          approaches, Snáithe champions progress in the wood and tire
          industries, redefining standards and driving eco-conscious growth.
          <br />
          <br />
          Mining & Cryptocurrency Industry: Snáithe's pioneering spirit extends
          to the mining and cryptocurrency sectors, where we facilitate
          responsible resource extraction and navigate the dynamic realm of
          digital currencies.
        </div>
      </div>
      <div className="image-container-right-1-2-custom">
        <img src={ManImage} alt="Square Image" />
      </div>
    </div>
  );
};

export default Businesses;
